/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_TitleInputs */

const en_plan_change_title = /** @type {(inputs: Plan_Change_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm your plan change`)
};

const es_plan_change_title = /** @type {(inputs: Plan_Change_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma el cambio de plan`)
};

/**
* | output |
* | --- |
* | "Confirm your plan change" |
*
* @param {Plan_Change_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_title = /** @type {((inputs?: Plan_Change_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_title(inputs)
	return en_plan_change_title(inputs)
});